<div class="card border-0 shadow-sm compose-card">
  <div class="card-header bg-white border-bottom">
    <div class="d-flex align-items-center">
      <i class="fas fa-pen-fancy text-primary mr-2" style="font-size: 1.1rem;"></i>
      <h6 class="mb-0 font-weight-bold">Nouveau message</h6>
    </div>
  </div>

  <div class="card-body">
    <!-- Alerte credit SMS -->
    <div class="alert alert-sms mb-3" [ngClass]="smsAlertClass" role="alert">
      <div class="d-flex align-items-center">
        <i class="fas fa-comment-dots mr-2" style="font-size: 1.1rem;"></i>
        <span>{{ smsAlertMessage }}</span>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- Compteur destinataires -->
      <div class="recipients-counter mb-3">
        <div class="d-flex align-items-center justify-content-center p-2">
          <i class="fas fa-users mr-2 text-primary"></i>
          <span class="font-weight-600">
            Nombre
            <span *ngIf="f.type.value === 'MAIL'">d'adresse(s) e-mail</span>
            <span *ngIf="f.type.value === 'SMS'">de numero de telephone</span>
            recuperee(s) :
          </span>
          <span class="badge badge-primary badge-pill ml-2 px-3 py-1">{{ nbMail }}</span>
        </div>
      </div>

      <!-- Type + Personnalisation -->
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label font-weight-600">
            <i class="fas fa-tag mr-1 text-muted"></i> Type d'envoi <span class="text-danger">*</span>
          </label>
          <select (change)="onType()" class="form-control custom-select" id="type" formControlName="type"
            [ngClass]="{ 'is-invalid': submit && f.type.errors, 'is-valid': submit && f.type.valid }">
            <option *ngFor="let item of typeRow" [value]="item?.value">{{ item?.label }}</option>
          </select>
        </div>
        <div class="col-md-6 mb-3">
          <label class="form-label font-weight-600">
            <i class="fas fa-user-friends mr-1 text-muted"></i> Destinataire <span class="text-danger">*</span>
          </label>
          <select (change)="onChangePersonalite($event.target.value)" class="form-control custom-select"
            formControlName="personalise" id="personalise"
            [ngClass]="{ 'is-invalid': submit && f.personalise.errors, 'is-valid': submit && f.personalise.valid }">
            <option *ngFor="let item of personalites" [value]="item.value" [disabled]="item.disabled">{{ item?.label }}</option>
          </select>
        </div>

        <!-- Categorie -->
        <div *ngIf="f.personalise.value === 'PROPRIETAIRE' || f.personalise.value === 'LOCATAIRE' || f.personalise.value === 'CLIENT' || f.personalise.value === 'PROSPECT'"
          [ngClass]="{'col-md-12': f.categorie.value === 'TOUT_PROPRIETAIRE' || f.categorie.value === 'TOUT_LOCATAIRE' || f.categorie.value === 'TOUT_PROSPECT' || f.categorie.value === 'IMPAYÉ' || f.categorie.value === 'TOUT_CLIENT' || f.categorie.value === null, 'col-md-6': f.categorie.value !== 'TOUT_PROPRIETAIRE' && f.categorie.value !== 'TOUT_LOCATAIRE' && f.categorie.value !== 'TOUT_PROSPECT' && f.categorie.value !== 'IMPAYÉ' && f.categorie.value !== 'TOUT_CLIENT' && f.categorie.value !== null}"
          class="mb-3">
          <label class="form-label font-weight-600">
            <i class="fas fa-layer-group mr-1 text-muted"></i> Categorie <span class="text-danger">*</span>
          </label>
          <select (ngModelChange)="onChangeCategorie($event)" class="form-control custom-select"
            formControlName="categorie" id="categorie"
            [ngClass]="{ 'is-invalid': submit && f.categorie.errors, 'is-valid': submit && f.categorie.valid }">
            <option *ngFor="let item of typageRow" [value]="item.value" [disabled]="item.disabled">{{ item?.label }}</option>
          </select>
        </div>

        <!-- Nombre d'impaye -->
        <div *ngIf="visible === 'LOCATIAIRE_IMPAYE'" class="col-md-3 mb-3">
          <label class="form-label font-weight-600">Nombre d'impaye <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="nombre" id="nombre" placeholder="Nombre d'impaye"
            [ngClass]="{ 'is-invalid': submit && f.nombre.errors, 'is-valid': submit && f.nombre.valid }">
        </div>

        <!-- Selection multiple (ng-select) -->
        <div *ngIf="visible === 'DEFINIR_PROPRIETAIRE' || visible === 'DEFINIR_LOCATIAIRE' || visible === 'DEFINIR_CLIENT' || visible === 'DEFINIR_PROSPECT'" class="col-md-6 mb-3">
          <label class="form-label font-weight-600">
            <i class="fas fa-search mr-1 text-muted"></i> {{ textePersonne }} <span class="text-danger">*</span>
          </label>
          <ng-select [multiple]="true" (ngModelChange)="definirPersonne($event)" class="form-control"
            formControlName="email"
            [ngClass]="{ 'is-invalid': submit && f.email.errors, 'is-valid': submit && f.categorie.valid }">
            <ng-option *ngFor="let item of categorieRow"
              [value]="f.type.value === 'MAIL' ? item.email : item.telephone">
              {{ item?.nom }} {{ f.type.value === 'MAIL' ? (item.email ? '' : ' - (Pas de email)') : (item?.telephone ? '' : ' - (Pas de numero)') }}
            </ng-option>
          </ng-select>
        </div>

        <!-- Selection simple -->
        <div *ngIf="visible === 'LOCATIAIRE_PROPRIETAIRE' || visible === 'TOUT_LOTISSEMENT'" class="col-md-6 mb-3">
          <label class="form-label font-weight-600">{{ textePersonne }} <span class="text-danger">*</span></label>
          <select (ngModelChange)="onChangeTiers($event, visible)" class="form-control custom-select" formControlName="email"
            [ngClass]="{ 'is-invalid': submit && f.email.errors, 'is-valid': submit && f.email.valid }">
            <option *ngFor="let item of categorieRow" [value]="item.uuid">{{ item?.nom }}</option>
          </select>
        </div>

        <div *ngIf="visible === 'TOUT_PROMOTION'" class="col-md-6 mb-3">
          <label class="form-label font-weight-600">{{ textePersonne }} <span class="text-danger">*</span></label>
          <select (change)="onChangeTiers($event.target.value, visible)" class="form-control custom-select" formControlName="email"
            [ngClass]="{ 'is-invalid': submit && f.email.errors, 'is-valid': submit && f.email.valid }">
            <option *ngFor="let item of categorieRow" [value]="item.uuid">{{ item?.libelle }}</option>
          </select>
        </div>

        <div *ngIf="visible === 'ETAT_PROSPECT'" class="col-md-6 mb-3">
          <label class="form-label font-weight-600">{{ textePersonne }} <span class="text-danger">*</span></label>
          <select (change)="onChangeTiers($event.target.value, visible)" class="form-control custom-select" formControlName="email"
            [ngClass]="{ 'is-invalid': submit && f.email.errors, 'is-valid': submit && f.email.valid }">
            <option *ngFor="let item of categorieRow" [value]="item.uuid">{{ item?.libelle }}</option>
          </select>
        </div>

        <div *ngIf="visible === 'LOCATIAIRE_IMPAYE'" class="col-md-6 mb-3">
          <label class="form-label font-weight-600">{{ textePersonne }} <span class="text-danger">*</span></label>
          <select (change)="onChangeTiers($event.target.value, visible)" class="form-control custom-select" formControlName="email"
            [ngClass]="{ 'is-invalid': submit && f.email.errors, 'is-valid': submit && f.email.valid }">
            <option *ngFor="let item of categorieRow" [value]="item.value">{{ item?.label }}</option>
          </select>
        </div>
      </div>

      <!-- Saisie manuelle -->
      <div *ngIf="f.personalise.value === 'DEFINIR'" class="mb-3">
        <div class="alert alert-warning border-0 shadow-sm">
          <div class="d-flex align-items-center">
            <i class="fas fa-info-circle mr-2"></i>
            <span>
              Afin de saisir plusieurs
              <span *ngIf="f.type.value === 'MAIL'">adresses e-mail</span>
              <span *ngIf="f.type.value === 'SMS'">numeros de telephone</span>,
              veuillez les separer en utilisant une virgule ou un espace blanc.
            </span>
          </div>
        </div>
        <label class="form-label font-weight-600">
          {{ f.type.value === 'MAIL' ? 'A' : 'Numero' }} <span class="text-danger">*</span>
        </label>
        <input (change)="onDestinataire($event)" type="email" class="form-control" formControlName="destinataire" id="destinataire"
          [placeholder]="f.type.value === 'MAIL' ? 'Email du ou des destinataire(s)' : 'Numero du ou des destinataire(s)'"
          [ngClass]="{ 'is-invalid': submit && f.destinataire.errors, 'is-valid': submit && f.destinataire.valid }">
        <div class="invalid-feedback" *ngIf="submit && f.destinataire.errors">
          <div *ngIf="f.destinataire.errors.required">Ce champ est obligatoire</div>
        </div>
      </div>

      <!-- Separateur -->
      <hr class="my-3">

      <!-- Objet -->
      <div class="mb-3">
        <label class="form-label font-weight-600">
          <i class="fas fa-heading mr-1 text-muted"></i> Objet
        </label>
        <input type="text" class="form-control" formControlName="objet" id="objet" placeholder="Objet du message"
          [ngClass]="{ 'is-invalid': submit && f.objet.errors, 'is-valid': submit && f.objet.valid }">
      </div>

      <!-- Editeur Mail (TinyMCE) -->
      <div *ngIf="f.type.value === 'MAIL'" class="mb-3">
        <label class="form-label font-weight-600">
          <i class="fas fa-align-left mr-1 text-muted"></i> Contenu du message
        </label>
        <app-tinymce formControlName="content" id="content" #tinymce='tinymce' aria-placeholder="Contenu du message"></app-tinymce>
      </div>

      <!-- Compteur SMS -->
      <div *ngIf="f.type.value === 'SMS'" class="mb-2">
        <div class="alert border-0 shadow-sm" [ngClass]="{
          'alert-primary': wordCount <= maxSms,
          'alert-warning': wordCount > maxSms
        }" role="alert">
          <div class="d-flex align-items-center justify-content-between">
            <span>
              <i class="fas fa-text-width mr-1"></i>
              Caracteres : <strong>{{ wordCount }}</strong> / {{ maxSms }}
            </span>
            <span *ngIf="smsPartsCount > 1" class="badge badge-warning badge-pill px-3">
              {{ smsPartsCount }} SMS consommes
            </span>
          </div>
        </div>
      </div>

      <!-- Textarea SMS -->
      <div *ngIf="f.type.value === 'SMS'" class="mb-3">
        <label class="form-label font-weight-600">
          <i class="fas fa-align-left mr-1 text-muted"></i> Contenu du message
        </label>
        <textarea (input)="countWords()" class="form-control"
          formControlName="content" id="content" placeholder="Contenu du message" rows="8"></textarea>
      </div>

      <!-- Bouton envoi -->
      <div class="d-flex justify-content-end mt-3">
        <button [disabled]="form.invalid" type="submit" class="btn btn-primary btn-send px-4">
          <i class="fas fa-paper-plane mr-2"></i> Envoyer
        </button>
      </div>
    </form>
  </div>
</div>
